import axios from 'axios';
import client from '@/lib/http-client';

const host = process.env.VUE_APP_MEDIA_URL || 'https://api.ostock.id/media';
const endpoint = '/upload';

export default {
	// Upload Image
	uploadImage(params, cb, errorCb, progressCallback) {
		const url = `${host}${endpoint}`;
		const config = {
			onUploadProgress: (progressEvent) => {
				const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
				if (progressCallback) progressCallback(percentCompleted);
			},
		};
		client.post(url, params, config)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// Upload Image for Public
	uploadImagePublic(params, cb, errorCb, progressCallback) {
		const url = `${host}${endpoint}/public`;
		const config = {
			onUploadProgress: (progressEvent) => {
				const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
				if (progressCallback) progressCallback(percentCompleted);
			},
		};
		client.post(url, params, config)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// Upload File
	uploadFile(params, cb, errorCb, progressCallback) {
		const url = `${host}${endpoint}/file`;
		const config = {
			onUploadProgress: (progressEvent) => {
				const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
				if (progressCallback) progressCallback(percentCompleted);
			},
		};
		client.post(url, params, config)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Upload Shipping Label
	uploadShippingLabel(params, cb, errorCb, progressCallback) {
		const url = `${host}${endpoint}/shipping-label`;
		const config = {
			onUploadProgress: (progressEvent) => {
				const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
				if (progressCallback) progressCallback(percentCompleted);
			},
		};
		client.post(url, params, config)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Remove File from S3
	remove(fileName, cb, errorCb) {
		const params = {
			image: fileName,
		};
		const url = `${host}${endpoint}`;
		axios.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Add Media
	add(params, cb, errorCb) {
		const url = '/media';
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Media List
	list(params, cb, errorCb) {
		const url = '/media';
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Delete Media
	deleteMedia(id, cb, errorCb) {
		const url = `/media/${id}`;
		client.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
